import React from 'react';
import PhotographyContent from '../components/Photography/PhotographyContent';
import Category from '../components/Photography/Category';

export default function Photography() {
  return (
    <main className="min-h-screen pt-24">
      <div className="page-container">
        <h1 className="text-4xl sm:text-5xl font-semibold text-foreground tracking-tight mb-4">
          Photography
        </h1>
        <p className="text-muted text-lg mb-12 max-w-2xl">
          Capturing moments through my lens - from travel adventures to portraits and products.
        </p>

        <Category />

        <div className="mt-16 border-t border-border pt-16">
          <PhotographyContent
            image={require("../images/Photography/instagramfeeds2025.png")}
            logo={require("../images/Photography/photog.png")}
          />
        </div>
      </div>
    </main>
  );
}
